import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import '@/config/client/i18n';

export default function ManifestoText() {
  const { t } = useTranslation('pages');

  return (
    <>
      <h2 className="font-brand-semibold">
        {t('Join HostFolk—Where Hospitality Meets Humanity')}
      </h2>
      <br />
      {t(
        `Whether you're opening your home or exploring the world, HostFolk is your gateway to meaningful connections.`,
      )}
      <br />
      <br />
      <Trans t={t} ns="pages">
        <strong>Become a Host</strong>: Share your space, your culture, and your
        kindness. Earn extra income while making a global impact.
      </Trans>
      {/* {t(
        `Become a Host: Share your space, your culture, and your kindness. Earn extra income while making a global impact.`,
      )} */}
      <br />
      <br />
      <Trans t={t} ns="pages">
        <strong>Find a Homestay</strong>: Experience life beyond the guidebook.
        Stay with locals, learn the language, and feel at home anywhere.
      </Trans>
      {/* {t(
        'Find a Homestay: Experience life beyond the guidebook. Stay with locals, learn the language, and feel at home anywhere.',
      )} */}
      <br />
      <br />
      {t(
        'Sign up today and be part of a movement that turns strangers into family.',
      )}
    </>
  );
}

ManifestoText.propTypes = {};
